export default function Marquee({ items }) {
  const list = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-white/10 py-6 bg-[#0a0a0a]">
      <div className="animate-marquee flex items-center gap-10">
        {list.map((t, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-4xl md:text-6xl font-semibold text-stroke tracking-tight">
              {t}
            </span>
            <span className="h-2 w-2 rounded-full bg-blue-500" />
          </span>
        ))}
      </div>
    </div>
  );
}
